module.exports = __webpack_public_path__ + "static/img/icon-1.5ede6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/icon-1.png
// module id = pPgf
// module chunks = 0